import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const isCanceledRequest = (errorResponse) => errorResponse.name === "CanceledError" || errorResponse.code === "ERR_CANCELED";

const filterItemsByPeriod = (items, period) => (period === "all" ? items : items.filter((item) => item.period === period));

const fetchReflections = async (period, signal) => {
  const query = period === "all" ? "" : `?period=${period}`;
  const response = await api.get(`/reflections${query}`, { signal });
  return response.data;
};

export const useHistoryData = (period) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const requestIdRef = useRef(0);

  useEffect(() => {
    const controller = new AbortController();
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;

    const loadItems = async () => {
      setLoading(true);
      setError("");
      try {
        const reflections = await fetchReflections(period, controller.signal);
        if (requestIdRef.current !== requestId) return;
        setItems(filterItemsByPeriod(reflections, period));
      } catch (errorResponse) {
        if (isCanceledRequest(errorResponse) || requestIdRef.current !== requestId) return;
        setError("Unable to load reflection history right now. Please try again shortly.");
        setItems([]);
      } finally {
        if (requestIdRef.current === requestId) setLoading(false);
      }
    };

    loadItems();
    return () => controller.abort();
  }, [period]);

  return { error, items, loading };
};